import React from "react";

type PropsType = {
  className?: string;
  size?: number;
};

const PrepInstructions: React.FC<PropsType> = ({ size = 60, className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 60 60"
      fill="none"
    >
      <g clip-path="url(#clip0_272_13095)">
        <rect width="60" height="60" fill="white" />
        <path d="M18.75 27L39.75 27" stroke="#003125" stroke-width="3" stroke-linecap="round" />
        <path d="M18.75 19.5L39.75 19.5" stroke="#003125" stroke-width="3" stroke-linecap="round" />
        <path d="M18.75 34.5L29.25 34.5" stroke="#003125" stroke-width="3" stroke-linecap="round" />
        <rect x="11.25" y="9" width="36" height="40.5" rx="4" stroke="#003125" stroke-width="3" />
        <circle cx="43.5" cy="45" r="18" fill="white" />
        <circle
          cx="43.5"
          cy="45"
          r="12"
          fill="#19FFBE"
          stroke="#003125"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle cx="43.4051" cy="39.6907" r="2.1375" fill="#003125" />
        <path
          d="M42.0687 45.2219C42.0687 44.1532 41 43.6187 41 43.6187C41 43.6187 42.8703 43.3516 43.9391 43.6187C45.0078 43.8859 45.275 44.5391 45.275 45.2219C45.275 45.9047 44.7406 49.4968 44.7406 50.5656C44.7406 51.6344 45.8094 52.1687 45.8094 52.1687C45.8094 52.1687 43.9391 52.4359 42.8703 52.1687C41.8016 51.9015 41.5344 51.2187 41.5344 50.5656C41.5344 49.9125 42.0687 46.2906 42.0687 45.2219Z"
          fill="#003125"
        />
      </g>
      <defs>
        <clipPath id="clip0_272_13095">
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PrepInstructions;
